import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'

// 게시판
// import Board from '../views/common/board/Board'
import BoardDetail from '../views/common/board/BoardDetail'
import BoardEdit from '../views/common/board/BoardEdit'
// // 공지사항
// import Notification from '../views/common/notification/Notification'
import NotificationDetail from '../views/common/notification/NotificationDetail'
import NotificationEdit from '../views/common/notification/NotificationEdit'

// 계정
import LoginPage from '../views/auth/LoginPage'
import JoinOrg from '../views/auth/JoinOrg'
import JoinPage from '../views/auth/JoinPage'
import JoinPhoneAuth from '../views/auth/JoinPhoneAuth'
import JoinProfileEdit from '../views/auth/JoinProfileEdit'
import JoinAuthSuccess from '../views/auth/join/JoinAuthSuccess'
import JoinAuthFail from '../views/auth/join/JoinAuthFail'
import JoinComplete from '../views/auth/JoinComplete'

import ProfilePage from '../views/auth/ProfilePage'
import PasswordChangePage from '../views/auth/PasswordChangePage'

// 학생 전용
import studentRouter from './studentRouter'
// Staff 전용
import staffRouter from './staffRouter'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home },
  // 계정
  { path: '/auth/login', name: 'Login', component: LoginPage },
  // { path: '/multi', name: 'JoinMulti', component: JoinPage },
  // { path: '/hpe', name: 'JoinHpe', component: JoinPage },
  { path: '/join', name: 'JoinOrg', component: JoinOrg },
  { path: '/:org', name: 'Join', component: JoinPage },
  { path: '/:org/join/phoneauth', name: 'JoinPhoneAuth', component: JoinPhoneAuth },
  { path: '/:org/join/authsuccess', name: 'JoinAuthSuccess', component: JoinAuthSuccess },
  { path: '/:org/join/authfail', name: 'JoinAuthFail', component: JoinAuthFail },
  { path: '/:org/join/profile', name: 'JoinProfileEdit', component: JoinProfileEdit },
  { path: '/:org/join/complete', name: 'JoinComplete', component: JoinComplete },
  { path: '/auth/profile', name: 'Profile', component: ProfilePage },
  { path: '/auth/passwordchangePage', name: 'PasswordChange', component: PasswordChangePage },

  // 학생
  ...studentRouter,
  // 교사/매니저/어드민
  ...staffRouter,
  // 공통
  { path: '/notification/view/:_id', name: 'NotificationDetail', component: NotificationDetail },
  { path: '/notification/edit/:_id', name: 'NotificationEdit', component: NotificationEdit },
  // { path: '/notification/edit', name: 'NotificationEdit', component: NotificationEdit },
  { path: '/board/view/:_id', name: 'BoardDetail', component: BoardDetail },
  { path: '/board/edit/:_id', name: 'BoardEdit', component: BoardEdit }
  // { path: '/board/edit', name: 'BoardEdit', component: BoardEdit }
  // 404
]

import Org from '@/models/Org'

async function addOrgRoute () {
  const orgs = await Org.list()
  orgs.forEach(o => {
    routes.push({ path: '/' + o.prefix, name: `Join${o.prefix}`, component: JoinPage })
  })
}
// addOrgRoute()

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
